import { fontFace, normalize } from 'polished';
import * as React from 'react';
import Helmet from 'react-helmet';
import { injectGlobal, ThemeProvider } from 'styled-components';

import { theme } from '@utils/theme';

import playfairDisplayBoldItalicWoff from '@assets/fonts/playfairdisplay-bolditalic.woff';
import playfairDisplayBoldItalicWoff2 from '@assets/fonts/playfairdisplay-bolditalic.woff2';
import playfairDisplayRegularWoff from '@assets/fonts/playfairdisplay-regular.woff';
import playfairDisplayRegularWoff2 from '@assets/fonts/playfairdisplay-regular.woff2';

const globalStyles = injectGlobal`
  ${normalize()}

  @font-face {
    font-family: "Playfair Display";
    font-style: normal;
    font-weight: normal;
    src: url(${playfairDisplayRegularWoff2}) format("woff2"),
        url(${playfairDisplayRegularWoff}) format("woff");
  }

  @font-face {
    font-family: "Playfair Display";
    font-style: italic;
    font-weight: bold;
    src: url(${playfairDisplayBoldItalicWoff2}) format("woff2"),
        url(${playfairDisplayBoldItalicWoff}) format("woff");
  }

  body {
    background-color: ${theme.colors.grey};
    color: ${theme.colors.nearBlack};
    font-family: ${theme.fontStack};
    font-size: 16px;
  }
`;

const Layout = ({ title = 'Todos', children }) => (
  <ThemeProvider theme={theme}>
    <React.Fragment>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </React.Fragment>
  </ThemeProvider>
);

export default Layout;
